export default __webpack_public_path__ + "static/media/job_offer14_m.a7657125.jpg";